export const hasUpperAndLoweCaseLettersRegExp = /((?=.*[a-z])(?=.*[A-Z]))/;
